import React, { Component } from "react";
import CssClasses from "./Balance.css";

import {
  SelectBalanceInfo,
  ExtrasClearDB
} from "../../../Communication/AdminServicesHandler";

import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";
import * as LocalStorageKeys from "../../../HOCs/Constants/LocalStorageKeys";

class Balance extends Component {
  billValues = [
    { id: 1, title: "10 BAM", centValue: 1000 },
    { id: 2, title: "20 BAM", centValue: 2000 },
    { id: 3, title: "50 BAM", centValue: 5000 },
    { id: 4, title: "100 BAM", centValue: 10000 },
    { id: 5, title: "200 BAM", centValue: 20000 }
  ];

  coinValues = [
    { id: 1, title: "0.05 BAM", centValue: 5 },
    { id: 2, title: "0.10 BAM", centValue: 10 },
    { id: 3, title: "0.20 BAM", centValue: 20 },
    { id: 4, title: "0.50 BAM", centValue: 50 },
    { id: 5, title: "1.00 BAM", centValue: 100 },
    { id: 6, title: "2.00 BAM", centValue: 200 },
    { id: 7, title: "5.00 BAM", centValue: 500 }
  ];

  billInfo = { noteInfo: [], summary: {} };
  coinInfo = { coinInfo: [], summary: {} };

  timer = null;
  state = {
    balanceItems: [],
    shouldQueryValidator: false
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    //updateaj i meceve info
    if (prevProps.tapeBillInfo !== this.props.tapeBillInfo) {
      //alert("tape bill info updated!");
      this.props.changeAdminLoadingIndicator(true);
      this.refreshBalanceData(false);
    }
  }

  componentDidMount() {
    this.props.changeAdminLoadingIndicator(true);
    this.refreshBalanceData(true);
  }

  render() {
    this.processBillInfo();
    this.processCoinInfo();

    console.log("MACHINE INFO IS ", this.props.machineInfo);

    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.contentBox}>
          <div className={CssClasses.tableSection}>
            <div className={CssClasses.row}>
              <div className={CssClasses.headerCell}>Novčanica</div>
              <div className={CssClasses.headerCell}>Na traci</div>
              <div className={CssClasses.headerCell}>U kutiji</div>
              <div className={CssClasses.headerCell}>Ukupno</div>
            </div>

            {this.billInfo.noteInfo.map(ni => {
              return (
                <div className={CssClasses.row} key={ni.id}>
                  <div className={CssClasses.dataCell}>{ni.title}</div>
                  <div className={CssClasses.dataCell}>
                    {ni.countTape} (max {ni.maxTape}) - total{" "}
                    {ni.sumTape.toFixed(2)}
                  </div>
                  <div className={CssClasses.dataCell}>
                    {ni.countBox} - total {ni.sumBox.toFixed(2)}
                  </div>
                  <div className={CssClasses.dataCell}>
                    {ni.countTotal} - total {ni.sumTotal.toFixed(2)}
                  </div>
                </div>
              );
            })}

            <div className={CssClasses.row}>
              <div className={CssClasses.headerCell}>UKUPNO:</div>
              <div className={CssClasses.headerCell}>
                {this.billInfo.summary.totalCountTape} - total{" "}
                {this.billInfo.summary.totalSumTape.toFixed(2)}
              </div>
              <div className={CssClasses.headerCell}>
                {this.billInfo.summary.totalCountBox} - total{" "}
                {this.billInfo.summary.totalSumBox.toFixed(2)}
              </div>
              <div className={CssClasses.headerCell}>
                {this.billInfo.summary.totalCountTotal} - total{" "}
                {this.billInfo.summary.totalSumTotal.toFixed(2)}
              </div>
            </div>

            <div className={CssClasses.spacer}>&nbsp;</div>
            <div className={CssClasses.row}>
              <div className={CssClasses.headerCell}>Kovanica</div>
              <div className={CssClasses.headerCell}>Na traci</div>
              <div className={CssClasses.headerCell}>U kutiji</div>
              <div className={CssClasses.headerCell}>Ukupno</div>
            </div>

            {this.coinInfo.coinInfo.map(ci => {
              return (
                <div className={CssClasses.row} key={ci.id}>
                  <div className={CssClasses.dataCell}>{ci.title}</div>
                  <div className={CssClasses.dataCell}>-</div>
                  <div className={CssClasses.dataCell}>
                    {ci.countBox} - total {ci.sumBox.toFixed(2)}
                  </div>
                  <div className={CssClasses.dataCell}>
                    {ci.countTotal} - total {ci.sumTotal.toFixed(2)}
                  </div>
                </div>
              );
            })}

            <div className={CssClasses.row}>
              <div className={CssClasses.headerCell}>UKUPNO:</div>
              <div className={CssClasses.headerCell}>-</div>
              <div className={CssClasses.headerCell}>
                {this.coinInfo.summary.totalCountBox} - total{" "}
                {this.coinInfo.summary.totalSumBox.toFixed(2)}
              </div>
              <div className={CssClasses.headerCell}>
                {this.coinInfo.summary.totalCountTotal} - total{" "}
                {this.coinInfo.summary.totalSumTotal.toFixed(2)}
              </div>
            </div>
          </div>

          <div className={CssClasses.actionsSection}>
            <button
              className={CssClasses.actionBtn}
              onClick={() => this.btnEmtpyToCashbox_Click()}
            >
              ISPRAZNI TRAKU U CASHBOX
            </button>
            <button
              className={CssClasses.actionBtn}
              onClick={() => this.btnEnterDepositMode_Click()}
            >
              ISPRAZNI KUTIJU S KOVANICAMA
            </button>
            <button
              className={CssClasses.actionBtn}
              onClick={() => this.btnResetBalance_Click()}
            >
              RESETIRANJE SALDA NA 0
            </button>
            <button
              className={CssClasses.actionBtn}
              onClick={() => this.btnEnterDepositMode_Click()}
            >
              MOD ZA NADOPUNU SALDA
            </button>
            <button
              className={CssClasses.actionBtn}
              onClick={() => this.btnRefreshData_Click()}
            >
              OSVJEŽI
            </button>
          </div>

          <div className={CssClasses.clearFix} />
        </div>
      </div>
    );
  }

  processBillInfo() {
    // if (!this.props.billInfo) {
    //   return;
    // }

    console.log("PROCESSING AT " + new Date());
    console.log(this.props.tapeBillInfo);

    var id = 0;

    var totalSumTape = 0;
    var totalSumBox = 0;
    var totalSumTotal = 0;

    var totalCountTape = 0;
    var totalCountBox = 0;
    var totalCountTotal = 0;

    //prazni
    this.billInfo = {};

    this.billInfo.noteInfo = [];
    this.billInfo.summary = {};

    this.props.tapeBillInfo.forEach(bi => {
      //obradi stanje na traci
      //obradi stanje na kutiji
      //obradi stanje ukupno

      //cent value pripremi
      var centValue = bi.Value * 100;

      var balanceItem = this.state.balanceItems.find(
        x => x.NominalValueCents === centValue && x.IsBill === true
      );

      if (!balanceItem) {
        //napravi dummy da ne bude null kurcine
        balanceItem = {
          CountAmount: 0,
          NominalValueCents: centValue,
          IsBill: true
        };
      }

      id++;

      var obj = {};

      obj.id = id;
      obj.title = bi.Value + " BAM";
      obj.countTape = bi.Count;
      obj.sumTape = bi.Count * bi.Value;

      switch (bi.Value) {
        case 10:
          obj.maxTape = this.props.machineInfo.MaximumBills10;
          break;
        case 20:
          obj.maxTape = this.props.machineInfo.MaximumBills20;
          break;
        case 50:
          obj.maxTape = this.props.machineInfo.MaximumBills50;
          break;
        case 100:
          obj.maxTape = this.props.machineInfo.MaximumBills100;
          break;
        case 200:
          obj.maxTape = this.props.machineInfo.MaximumBills200;
          break;

        default:
          obj.maxTape = 0;
      }

      obj.countBox = balanceItem.CountAmount - bi.Count;
      obj.sumBox = balanceItem.CountAmount * bi.Value - bi.Count * bi.Value;

      obj.countTotal = balanceItem.CountAmount;
      obj.sumTotal = balanceItem.CountAmount * bi.Value;

      totalSumTape += obj.sumTape;
      totalSumBox += obj.sumBox;
      totalSumTotal += obj.sumTotal;

      totalCountTape += obj.countTape;
      totalCountBox += obj.countBox;
      totalCountTotal += obj.countTotal;

      this.billInfo.noteInfo.push(obj);
    });

    this.billInfo.summary.totalSumTape = totalSumTape;
    this.billInfo.summary.totalSumBox = totalSumBox;
    this.billInfo.summary.totalSumTotal = totalSumTotal;

    this.billInfo.summary.totalCountTape = totalCountTape;
    this.billInfo.summary.totalCountBox = totalCountBox;
    this.billInfo.summary.totalCountTotal = totalCountTotal;

    //logiraj za test
    console.log(this.billInfo);

    //ako imamo timer i count svega je 0, znaci da je bio emptying
    if (this.timer && totalCountTape === 0) {
      clearInterval(this.timer);
    }
  }

  processCoinInfo() {
    console.log("PROCESSING AT " + new Date());

    var id = 0;

    var totalSumBox = 0;
    var totalSumTotal = 0;

    var totalCountBox = 0;
    var totalCountTotal = 0;

    //prazni
    this.coinInfo = {};

    this.coinInfo.coinInfo = [];
    this.coinInfo.summary = {};

    var coinInfos = this.state.balanceItems.filter(x => x.IsBill === false);

    coinInfos.forEach(ci => {
      //obradi stanje na traci
      var obj = {};

      obj.id = id;
      obj.title = (ci.NominalValueCents * 0.01).toFixed(2) + " BAM";

      obj.countBox = ci.CountAmount;
      obj.sumBox = ci.CountAmount * ci.NominalValueCents * 0.01;

      obj.countTotal = obj.countBox;
      obj.sumTotal = obj.sumBox;

      totalSumBox += obj.sumBox;
      totalSumTotal += obj.sumTotal;

      totalCountBox += obj.countBox;
      totalCountTotal += obj.countTotal;

      this.coinInfo.coinInfo.push(obj);
    });

    this.coinInfo.summary.totalSumBox = totalSumBox;
    this.coinInfo.summary.totalSumTotal = totalSumTotal;

    this.coinInfo.summary.totalCountBox = totalCountBox;
    this.coinInfo.summary.totalCountTotal = totalCountTotal;

    //logiraj za test
    console.log(this.coinInfo);
  }

  btnEmtpyToCashbox_Click() {
    this.props.changeAdminLoadingIndicator(true);

    //napravi interval
    this.timer = setInterval(() => {
      this.props.changeAdminLoadingIndicator(true);
      this.refreshBalanceData(true);
    }, 5000);

    window.cefCustomObject.emptyValidatorToCashbox();
  }

  btnEnterDepositMode_Click() {}

  btnResetBalance_Click() {
    ExtrasClearDB(
      function() {
        this.refreshBalanceData(true);
      }.bind(this)
    );
  }

  btnRefreshData_Click() {
    this.props.changeAdminLoadingIndicator(true);
    this.refreshBalanceData(true);
  }

  refreshBalanceData(shouldQueryValidator) {
    this.setState({ shouldQueryValidator: shouldQueryValidator });

    SelectBalanceInfo(
      this.props.machineInfo.MachineGUID,
      this.selectBalanceInfo_Callback.bind(this)
    );
  }

  selectBalanceInfo_Callback(val) {
    console.log("IN CALLBACK ", val);

    this.setState({ balanceItems: val });

    if (this.state.shouldQueryValidator) {
      //imas stanje sa servisa, zovi da dobijes stanje na traci
      window.cefCustomObject.refreshValidatorTapeBillCount();
    } else {
      //obradi
      this.processBillInfo();
      this.processCoinInfo();
    }
  }
}

const mapStateToProps = state => {
  return {
    isAdminLoadingShown: state.rrNavigation.isAdminLoadingShown,
    tapeBillInfo: state.rrAppState.tapeBillInfo,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeAdminLoadingIndicator: isLoading =>
      dispatch(StoreActions.ChangeAdminLoadingIndicator(isLoading))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Balance);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/Balance/Balance.js